<template>
    <div>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <Pengajuan v-if="viewstate===0"/>
        <SedangMenunggu  v-if="viewstate===9"/>
        <Loanformrequest v-if="viewstate===1"/>
        <Dashboardcapital v-if="viewstate===2" />
    </div>
</template>

<script>
    import Pengajuan from "@/components/irmacapital/pengajuan";
    import Loanformrequest from "@/components/irmacapital/formrequest";
    import {mapActions, mapState} from "vuex";
    import Dashboardcapital from "@/components/irmacapital/dashboardcapital";
    import SedangMenunggu from "@/components/irmacapital/SedangMenunggu";
    export default {
        name: "IRMACapital",
        components: {SedangMenunggu, Dashboardcapital, Loanformrequest, Pengajuan},
        data: () => ({

        }),
        mounted(){
            this.getLoan()

        },
        computed: {
            ...mapState('Loan',['viewstate','loan','loading'])
        },
        methods: {
            ...mapActions('Loan',['setviewstate','getLoan'])
        }
    }
</script>

<style scoped>

</style>
